import React from 'react';
import _sortBy from 'lodash/sortBy';
import _reverse from 'lodash/reverse';

import i18n from 'lib/i18n';
import Table from 'components//Table';
import Box from 'components/react-styled-core/Box';

const render = value => value || '-';

const RuleList = () => {
    const columns = [
        {
            title: i18n._('Name'),
            width: '40%',
            dataKey: 'name',
            render
        },
        {
            title: i18n._('Application Type'),
            width: 180,
            dataKey: 'applicationType',
            render
        },
        {
            title: i18n._('Severity'),
            width: 10,
            dataKey: 'severity',
            render
        },
        {
            title: i18n._('CVE'),
            width: 100,
            dataKey: 'cve',
            render
        },
        {
            title: i18n._('Microsoft'),
            width: 100,
            dataKey: 'microsoft',
            render
        },
        {
            title: i18n._('Last Updated'),
            width: 70,
            dataKey: 'lastUpdated',
            render
        }
    ];
    const data = [
        {
            name: 'Microsoft Lync Insecure Library Loading Vulnerability Over Network Share (CVE-2012-1849)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2012-1849',
            microsoft: 'Microsoft-MS12-039',
            lastUpdated: '2018-09-10'
        },
        {
            name: 'Microsoft Windows SMB Tree Connect Response Denial Of Service Vulnerability (CVE-2017-0016)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('High'),
            cve: 'Mitre CVE-2017-0016',
            microsoft: 'Microsoft-MS17-012',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Microsoft Windows RPC Downgrade Vulnerability (CVE-2016-0128)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Medium'),
            cve: 'Mitre CVE-2016-0128',
            microsoft: 'Microsoft-MS16-047',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Windows Components Insecure Library Loading Vulnerability Over Network Share (CVE-2011-1991)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2011-1991',
            microsoft: 'Microsoft-MS11-071',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'SMB Null Pointer Vulnerability',
            applicationType: 'DCERPC Services',
            severity: i18n._('High'),
            cve: 'Mitre CVE-2010-0022',
            microsoft: 'Microsoft-MS10-012',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'Microsoft Windows Search Remote Code Execution Vulnerability (CVE-2017-8620)',
            applicationType: 'DCERPC Services',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2017-8620',
            microsoft: '',
            lastUpdated: '2018-08-27'
        },
        {
            name: 'SMB Memory Corruption Vulnerability',
            applicationType: 'DCERPC Services',
            severity: i18n._('High'),
            cve: 'Mitre CVE-2010-0021',
            microsoft: 'Microsoft-MS10-012',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'SMB Response Parsing Vulnerability (CVE-2011-1268)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2011-1268',
            microsoft: 'Microsoft-MS11-043',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Microsoft Expression Design Insecure Library Loading Vulnerability Over Network Share (CVE-2012-0016)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2012-0016',
            microsoft: 'Microsoft-MS12-022',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Microsoft Windows Server Message Block Memory Corruption Vulnerability (CVE-2015-2474)',
            applicationType: 'DCERPC Services',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2015-2474',
            microsoft: 'Microsoft-MS15-083',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'SMB Request Parsing Vulnerability (CVE-2011-1267)',
            applicationType: 'DCERPC Services',
            severity: i18n._('High'),
            cve: 'Mitre CVE-2011-1267',
            microsoft: 'Microsoft-MS11-048',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Adobe Flash Player DLL Hijacking Vulnerability Over Network Share (CVE-2016-4140)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2016-4140',
            microsoft: '',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'SMB Transaction Parsing Vulnerability (CVE-2011-0661)',
            applicationType: 'DCERPC Services',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2011-0661',
            microsoft: 'Microsoft-MS11-020',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'Microsoft Windows LNK Remote Code Execution Over SMB (CVE-2017-8464)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2017-8464',
            microsoft: '',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Vulnerability In Windows Shell Could Allow Remote Code Execution (CVE-2012-0175)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2012-0175',
            microsoft: 'Microsoft-MS12-048',
            lastUpdated: '2018-09-10'
        },
        {
            name: 'SMB Variable Validation Vulnerability',
            applicationType: 'DCERPC Services',
            severity: i18n._('High'),
            cve: 'Mitre CVE-2010-2551',
            microsoft: 'Microsoft-MS10-054',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'License Logging Server Heap Overflow Vulnerability',
            applicationType: 'DCERPC Services',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2009-2523',
            microsoft: 'Microsoft-MS09-064',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'Identified Client Suspicious SMB Session',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2017-0148',
            microsoft: 'Microsoft-MS17-010',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'SMB Stack Exhaustion Vulnerability',
            applicationType: 'DCERPC Services',
            severity: i18n._('High'),
            cve: 'Mitre CVE-2010-2552',
            microsoft: 'Microsoft-MS10-054',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'SMB Pathname Overflow Vulnerability',
            applicationType: 'DCERPC Services',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2010-0020',
            microsoft: 'Microsoft-MS10-012',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'Telnet Handler Remote Code Execution Vulnerability Over Network Share (CVE-2011-1961)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2011-1961',
            microsoft: 'Microsoft-MS11-057',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'DFS Memory Corruption Vulnerability (CVE-2011-1868)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2011-1868',
            microsoft: 'Microsoft-MS11-042',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'PowerPoint Insecure Library Loading Vulnerability Over Network Share (CVE-2011-3396)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2011-3396',
            microsoft: 'Microsoft-MS11-094',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Microsoft Windows SMB Remote Code Execution Vulnerability (CVE-2017-0145)',
            applicationType: 'DCERPC Services',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2017-0145',
            microsoft: 'Microsoft-MS17-010',
            lastUpdated: '2018-11-22'
        },
        {
            name: 'Skype Insecure Library Loading Vulnerability Over Network Share (CVE-2017-6517)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2017-6517',
            microsoft: '',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Pointer Reference Memory Corruption Vulnerability Domain Blocker',
            applicationType: 'DNS Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2008-4844',
            microsoft: 'Microsoft-ms08-078',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'Adobe Flash Player Remote Arbitrary Code Execution Vulnerability (CVE-2013-2555)',
            applicationType: 'RTMP Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2013-2555',
            microsoft: '',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Microsoft Windows SMB Remote Code Execution Vulnerability (MS17-010)',
            applicationType: 'DCERPC Services',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2017-0148',
            microsoft: 'Microsoft-MS17-010',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'SMB Client Response Parsing Vulnerability',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2010-0476',
            microsoft: 'Microsoft-MS10-020',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'Microsoft Active Directory \'BROWSER ELECTION\' Buffer Overflow Vulnerability',
            applicationType: 'DCERPC Services',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2011-0654',
            microsoft: 'Microsoft-MS11-019',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'Windows Mail Insecure Library Loading Vulnerability Over Network Share (CVE-2011-2016)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2011-2016',
            microsoft: 'Microsoft-MS11-085',
            lastUpdated: '2018-09-10'
        },
        {
            name: 'Microsoft Windows RPC Downgrade Vulnerability (CVE-2016-0128) - 1',
            applicationType: 'Windows Services RPC Client DCERPC',
            severity: i18n._('Medium'),
            cve: 'Mitre CVE-2016-0128',
            microsoft: 'Microsoft-MS16-047',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Microsoft Windows OLE Remote Code Execution Vulnerability Over SMB',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2014-6352',
            microsoft: 'Microsoft-MS14-064',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Server Service Vulnerability (wkssvc)',
            applicationType: 'DCERPC Services',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2008-4250',
            microsoft: 'Microsoft-08-067',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'Microsoft Visio Insecure Library Loading Vulnerability Over Network Share (CVE-2010-3148)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2010-3148',
            microsoft: 'Microsoft-MS11-055',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Adobe Flash Player DLL Hijacking Vulnerability Over Network Share (CVE-2016-1014)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('High'),
            cve: 'Mitre CVE-2016-1014',
            microsoft: '',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Microsoft Windows Local Security Authority Subsystem Service Denial Of Service Vulnerability (CVE-2016-7237)',
            applicationType: 'DCERPC Services',
            severity: i18n._('Medium'),
            cve: 'Mitre CVE-2016-7237',
            microsoft: 'Microsoft-MS16-137',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Microsoft Windows Search Remote Code Execution Vulnerability (CVE-2017-8543)',
            applicationType: 'DCERPC Services',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2017-8543',
            microsoft: '',
            lastUpdated: '2018-08-27'
        },
        {
            name: 'SMB DLL Injection Exploit Detected',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Low'),
            cve: '',
            microsoft: '',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Print Spooler Service Format String Vulnerability (CVE-2012-1851) II',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2012-1851',
            microsoft: 'Microsoft-MS12-054',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Microsoft Windows SMB Information Disclosure Vulnerability (CVE-2017-0147)',
            applicationType: 'DCERPC Services',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2017-0147',
            microsoft: 'Microsoft-MS17-010',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Data Access Components Insecure Library Loading Vulnerability Over Network Share (CVE-2011-1975)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2011-1975',
            microsoft: 'Microsoft-MS11-059',
            lastUpdated: '2018-09-10'
        },
        {
            name: 'Malware AGENT.BTZ Domain Blocker',
            applicationType: 'DNS Client',
            severity: i18n._('Medium'),
            cve: '',
            microsoft: '',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'Microsoft Windows Remote Desktop Protocol Remote Code Execution Vulnerability (CVE-2017-0176)',
            applicationType: 'Remote Desktop Protocol Server',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2017-0176',
            microsoft: '',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Microsoft Windows SMB Remote Code Execution Vulnerabilities (CVE-2017-0144 and CVE-2017-0146)',
            applicationType: 'DCERPC Services',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2017-0144',
            microsoft: 'Microsoft-MS17-010',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'DNS Malformed Response Detected',
            applicationType: 'DNS Client',
            severity: i18n._('Medium'),
            cve: 'Mitre CVE-2015-7547',
            microsoft: '',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Windows Port Mapper Decoder',
            applicationType: 'Port Mapper Windows',
            severity: i18n._('High'),
            cve: '',
            microsoft: '',
            lastUpdated: '2018-09-17'
        },
        {
            name: 'Microsoft Office Chinese Grammar Checking Vulnerability Over Network Share (CVE-2014-1756)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2014-1756',
            microsoft: 'Microsoft-MS14-023',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Windows Client Port Mapper Decoder',
            applicationType: 'Windows Services RPC Client DCERPC',
            severity: i18n._('High'),
            cve: 'Mitre CVE-2016-0128',
            microsoft: 'Microsoft-MS16-047',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Executable File Download On Network Share Detected',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Low'),
            cve: '',
            microsoft: '',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Print Spooler Load Library Vulnerability',
            applicationType: 'DCERPC Services',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2009-0230',
            microsoft: 'Microsoft-MS09-022',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'SMB Client Memory Allocation Vulnerability',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2010-0269',
            microsoft: 'Microsoft-MS10-020',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'SMBv2 Infinite Loop Vulnerability',
            applicationType: 'DCERPC Services',
            severity: i18n._('High'),
            cve: 'Mitre CVE-2009-2526',
            microsoft: 'Microsoft-MS09-050',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'Identified Server Suspicious SMB Session',
            applicationType: 'DCERPC Services',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2017-0148',
            microsoft: 'Microsoft-MS17-010',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Microsoft Windows DNSAPI Remote Code Execution Vulnerability (CVE-2018-8225)',
            applicationType: 'DNS Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2018-8225',
            microsoft: '',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Microsoft Windows DLL Loading Vulnerabilities Over Network Share (MS16-007)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Medium'),
            cve: 'Mitre CVE-2016-0014',
            microsoft: 'Microsoft-MS16-007',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Identified BADRABBIT Ransomware Propagation Over SMB',
            applicationType: 'DCERPC Services',
            severity: i18n._('Critical'),
            cve: '',
            microsoft: '',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Windows Netlogon Service Denial Of Service (CVE-2010-2742)',
            applicationType: 'DCERPC Services',
            severity: i18n._('Medium'),
            cve: 'Mitre CVE-2010-2742',
            microsoft: 'Microsoft-MS10-101',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'SMB Client Response Parsing Vulnerability (CVE-2011-0660)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2011-0660',
            microsoft: 'Microsoft-MS11-019',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'Microsoft Windows DLL Loading Vulnerabilities Over Network Share (MS15-132)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('High'),
            cve: 'Mitre CVE-2015-6133',
            microsoft: 'Microsoft-MS15-132',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Microsoft Internet Explorer Information Disclosure Vulnerability Over SMB (CVE-2016-3321)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Low'),
            cve: 'Mitre CVE-2016-3321',
            microsoft: 'Microsoft-MS16-095',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Microsoft Windows SMBv3 Denial Of Service Vulnerability (CVE-2018-0833)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Medium'),
            cve: 'Mitre CVE-2018-0833',
            microsoft: '',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Microsoft Windows DLL Loading Vulnerability Over Network Share (CVE-2017-0039)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2017-0039',
            microsoft: 'Microsoft-MS17-012',
            lastUpdated: '2018-08-27'
        },
        {
            name: 'Microsoft Windows Insecure Binary Loading Vulnerability Over Network Share (CVE-2014-0315)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Medium'),
            cve: 'Mitre CVE-2014-0315',
            microsoft: 'Microsoft-MS14-019',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Microsoft Visual Basic for Applications Insecure Library Loading Vulnerability Over Network Share (CVE-2012-1854)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Medium'),
            cve: 'Mitre CVE-2012-1854',
            microsoft: 'Microsoft-MS12-046',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Microsoft Windows DLL Loading Vulnerabilities Over Network Share (CVE-2016-0160 and CVE-2016-0148)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('High'),
            cve: 'Mitre CVE-2016-0160',
            microsoft: 'Microsoft-MS16-037',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Microsoft Windows SMB Server SMBv1 Information Disclosure Vulnerability (CVE-2017-11815)',
            applicationType: 'DCERPC Services',
            severity: i18n._('Low'),
            cve: 'Mitre CVE-2017-11815',
            microsoft: '',
            lastUpdated: '2018-08-27'
        },
        {
            name: 'SMB Client Pool Corruption Vulnerability',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2010-0016',
            microsoft: 'Microsoft-MS10-006',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'Microsoft Windows \'CreateSizedDIBSECTION()\' Thumbnail View Stack Buffer Overflow Vulnerability Over Network Share',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2010-3970',
            microsoft: 'Microsoft-MS11-006',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'Microsoft Windows SMB Remote Code Execution Vulnerability (CVE-2017-0148)',
            applicationType: 'DCERPC Services',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2017-0148',
            microsoft: 'Microsoft-MS17-010',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Microsoft Windows SMB Information Disclosure Vulnerability (CVE-2017-0267)',
            applicationType: 'DCERPC Services',
            severity: i18n._('Medium'),
            cve: 'Mitre CVE-2017-0267',
            microsoft: '',
            lastUpdated: '2018-08-27'
        },
        {
            name: 'Microsoft Office OLE DLL Loading Vulnerability Over Network Share (CVE-2016-7275)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('High'),
            cve: 'Mitre CVE-2016-7275',
            microsoft: 'Microsoft-MS16-148',
            lastUpdated: '2018-08-27'
        },
        {
            name: 'Microsoft Office DLL Loading Vulnerability Over Network Share (CVE-2017-0197)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2017-0197',
            microsoft: '',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Identified Windows DCERPC AUTH LEVEL CONNECT Password Validate Request',
            applicationType: 'Windows Services RPC Server DCERPC',
            severity: i18n._('Medium'),
            cve: 'Mitre CVE-2016-0128',
            microsoft: 'Microsoft-MS16-047',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Adobe Acrobat DLL Loading Arbitrary Code Execution Vulnerability (CVE-2016-1008)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('High'),
            cve: 'Mitre CVE-2016-1008',
            microsoft: '',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Adobe Multiple Products PDF JavaScript Method Buffer Overflow',
            applicationType: 'DNS Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2007-5659',
            microsoft: '',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'Microsoft Windows Search Remote Code Execution Vulnerability (CVE-2017-11771)',
            applicationType: 'DCERPC Services',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2017-11771',
            microsoft: '',
            lastUpdated: '2018-08-27'
        },
        {
            name: 'Print Spooler Service Format String Vulnerability (CVE-2012-1851)',
            applicationType: 'DCERPC Services',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2012-1851',
            microsoft: 'Microsoft-MS12-054',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Active Accessibility Insecure Library Loading Vulnerability (CVE-2011-1247)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2011-1247',
            microsoft: 'Microsoft-MS11-075',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Microsoft Windows Local Security Authority Subsystem Service (LSASS) Denial Of Service Vulnerability (CVE-2017-0004)',
            applicationType: 'DCERPC Services',
            severity: i18n._('High'),
            cve: 'Mitre CVE-2017-0004',
            microsoft: 'Microsoft-MS17-004',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Adobe Acrobat DLL Loading Arbitrary Code Execution Vulnerability Over Network Share (CVE-2017-3013)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2017-3013',
            microsoft: '',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Microsoft Filter Manager Elevation Of Privilege Vulnerability (CVE-2018-8333)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2018-8333',
            microsoft: '',
            lastUpdated: '2018-10-15'
        },
        {
            name: 'Adobe Flash Player Memory Corruption Vulnerability (CVE-2014-0551)',
            applicationType: 'RTMP Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2014-0551',
            microsoft: '',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Adobe Flash Player Object Confusion Vulnerability (CVE-2012-0779)',
            applicationType: 'RTMP Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2012-0779',
            microsoft: '',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Microsoft SMB Credential Reflection Vulnerability',
            applicationType: 'DCERPC Services',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2008-4037',
            microsoft: 'Microsoft-MS08-068',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Oracle Java JRE Insecure Executable Loading Vulnerability Over Network Share',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: '',
            microsoft: '',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Microsoft Windows DLL Loading Vulnerability Over Network Share (CVE-2016-0100)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('High'),
            cve: 'Mitre CVE-2016-0100',
            microsoft: 'Microsoft-MS16-025',
            lastUpdated: '2018-08-27'
        },
        {
            name: 'Remote Desktop Protocol Vulnerability (CVE-2012-2526)',
            applicationType: 'Remote Desktop Protocol Server',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2012-2526',
            microsoft: 'Microsoft-MS12-053',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'SMB Client Race Condition Vulnerability',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2010-0017',
            microsoft: 'Microsoft-MS10-006',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'Indeo Codec Insecure Library Loading Vulnerability Over Network Share (CVE-2010-3138)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2010-3138',
            microsoft: 'Microsoft-MS12-014',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Microsoft Windows DNSAPI Remote Code Execution Vulnerability (CVE-2017-11779)',
            applicationType: 'DNS Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2017-11779',
            microsoft: '',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Intel Active Management Technology Escalation Of Privilege (CVE-2017-5689)',
            applicationType: 'Intel AMT',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2017-5689',
            microsoft: '',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Microsoft Windows Briefcase Integer Overflow Vulnerability Over Network Share (CVE-2012-1528)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2012-1528',
            microsoft: 'Microsoft-MS12-072',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Foxit Reader Arbitrary DLL Injection Code Execution Vulnerability Over Network Share',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('High'),
            cve: '',
            microsoft: '',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Microsoft Windows SMB Buffer Underflow Vulnerability',
            applicationType: 'DCERPC Services',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2008-4038',
            microsoft: 'Microsoft-MS08-063',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'Adobe Flash Player Remote Security Bypass Vulnerability Over Network Share (CVE-2012-0756)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2012-0756',
            microsoft: '',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Microsoft Windows DLL Loading Vulnerabilities Over Network Share (MS16-014)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('High'),
            cve: 'Mitre CVE-2016-0041',
            microsoft: 'Microsoft-MS16-014',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Microsoft Windows Briefcase Integer Underflow Vulnerability Over Network Share (CVE-2012-1527)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2012-1527',
            microsoft: 'Microsoft-MS12-072',
            lastUpdated: '2018-09-10'
        },
        {
            name: 'SMB Credential Reflection Vulnerability',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2008-4037',
            microsoft: 'Microsoft-MS08-068',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'SMB Pool Overflow Vulnerability',
            applicationType: 'DCERPC Services',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2010-2550',
            microsoft: 'Microsoft-MS10-054',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'Print Spooler Service Impersonation Vulnerability',
            applicationType: 'DCERPC Services',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2010-2729',
            microsoft: 'Microsoft-MS10-061',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'Microsoft Windows \'KeAccumulateTicks()\' SMB2 Packet Remote Denial Of Service Vulnerability',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('High'),
            cve: 'Mitre CVE-2009-3676',
            microsoft: 'Microsoft-MS10-006',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'OLE Automation Underflow Vulnerability ( CVE-2011-0658 )',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2011-0658',
            microsoft: 'Microsoft-MS11-038',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Local Security Authority Subsystem Service Integer Overflow Vulnerability',
            applicationType: 'Windows Services RPC Server DCERPC',
            severity: i18n._('High'),
            cve: 'Mitre CVE-2009-2524',
            microsoft: 'Microsoft-MS09-059',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'Identified Suspicious Microsoft DLL File Over Network Share',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2011-0032',
            microsoft: 'Microsoft-MS11-015',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'Object Packager Insecure Executable Launching Vulnerability Over Network Share (CVE-2012-0009)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2012-0009',
            microsoft: 'Microsoft-MS12-002',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Microsoft Word Malformed Object Pointer Remote Code Execution',
            applicationType: 'DNS Client',
            severity: i18n._('High'),
            cve: 'Mitre CVE-2006-2492',
            microsoft: 'Microsoft-MS06-027',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'Adobe Flash Player Multimedia File Remote Buffer Overflow Vulnerability',
            applicationType: 'DNS Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2007-0071',
            microsoft: '',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'Microsoft Windows SMB Out-Of-Bounds Read Denial Of Service Vulnerability (CVE-2017-11781)',
            applicationType: 'DCERPC Services',
            severity: i18n._('High'),
            cve: 'Mitre CVE-2017-11781',
            microsoft: '',
            lastUpdated: '2018-08-27'
        },
        {
            name: 'Remote Administration Protocol Stack Overflow Vulnerability',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2012-1853',
            microsoft: 'Microsoft-MS12-054',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Color Control Panel Insecure Library Loading Vulnerability Over Network Share (CVE-2010-5082)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2010-5082',
            microsoft: 'Microsoft-MS12-012',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Microsoft Windows svcctl ChangeServiceConfig2A() Memory Corruption Vulnerability',
            applicationType: 'DCERPC Services',
            severity: i18n._('Low'),
            cve: '',
            microsoft: '',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'Integer Overflow In IPP Service Vulnerability',
            applicationType: 'DCERPC Services',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2008-1446',
            microsoft: 'Microsoft-MS08-062',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'Microsoft Windows SMBv1 Information Disclosure Vulnerability (CVE-2017-0271)',
            applicationType: 'DCERPC Services',
            severity: i18n._('Medium'),
            cve: 'Mitre CVE-2017-0271',
            microsoft: '',
            lastUpdated: '2018-08-27'
        },
        {
            name: 'SMB NTLM Authentication Lack Of Entropy Vulnerability',
            applicationType: 'DCERPC Services',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2010-0231',
            microsoft: 'Microsoft-MS10-012',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'Microsoft Visio OLE DLL Loading Arbitrary Code Execution Vulnerability Over Network Share (CVE-2016-3235)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2016-3235',
            microsoft: 'Microsoft-MS16-070',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'SMB Client Message Size Vulnerability',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2010-0477',
            microsoft: 'Microsoft-MS10-020',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'SMB Client Transaction Vulnerability',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2010-0270',
            microsoft: 'Microsoft-MS10-020',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'Remote Desktop Protocol Vulnerability (CVE-2012-0002)',
            applicationType: 'Remote Desktop Protocol Server',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2012-0002',
            microsoft: 'Microsoft-MS12-020',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Adobe Flash Player Memory Corruption Vulnerability (CVE-2014-0549)',
            applicationType: 'RTMP Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2014-0549',
            microsoft: '',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Microsoft Windows DLL Planting Remote Code Execution Vulnerability (CVE-2015-0096)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2015-0096',
            microsoft: 'Microsoft-MS15-020',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Microsoft Windows SMBv1 Remote Code Execution Vulnerability',
            applicationType: 'DCERPC Services',
            severity: i18n._('Medium'),
            cve: '',
            microsoft: '',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Microsoft Windows CredSSP Remote Code Execution Vulnerability (CVE-2018-0886)',
            applicationType: 'Remote Desktop Protocol Client',
            severity: i18n._('High'),
            cve: 'Mitre CVE-2018-0886',
            microsoft: '',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Microsoft Windows CHM Notepad Remote Code Execution',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Medium'),
            cve: '',
            microsoft: '',
            lastUpdated: '2018-09-04'
        },
        {
            name: 'DNSMessenger Malware C&C Traffic Over DNS Protocol',
            applicationType: 'DNS Client',
            severity: i18n._('Medium'),
            cve: '',
            microsoft: '',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Kingsoft Office Path Subversion Arbitrary DLL Injection Code Execution Vulnerability Over Network Share',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Medium'),
            cve: 'Mitre CVE-2010-5208',
            microsoft: '',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Remote Administration Protocol Denial Of Service Vulnerability (CVE-2012-1850)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Medium'),
            cve: 'Mitre CVE-2012-1850',
            microsoft: 'Microsoft-MS12-054',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Microsoft Windows NETLOGON Spoofing Vulnerability (CVE-2015-0005)',
            applicationType: 'DCERPC Services',
            severity: i18n._('Medium'),
            cve: 'Mitre CVE-2015-0005',
            microsoft: 'Microsoft-MS15-027',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'DNSMessenger Malware Domain Blocker',
            applicationType: 'DNS Client',
            severity: i18n._('Medium'),
            cve: '',
            microsoft: '',
            lastUpdated: '2018-09-25'
        },
        {
            name: 'Microsoft Windows Remote Desktop Protocol (RDP) Remote Code Execution Vulnerability (CVE-2015-2373)',
            applicationType: 'Remote Desktop Protocol Server',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2015-2373',
            microsoft: 'Microsoft-MS15-067',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'Internet Explorer Insecure Library Loading Vulnerability Over Network Share (CVE-2011-2019)',
            applicationType: 'DCERPC Services - Client',
            severity: i18n._('Critical'),
            cve: 'Mitre CVE-2011-2019',
            microsoft: 'Microsoft-MS11-099',
            lastUpdated: '2018-09-27'
        },
        {
            name: 'DNS Request To ShadowPad Domain Detection',
            applicationType: 'DNS Client',
            severity: i18n._('High'),
            cve: '',
            microsoft: '',
            lastUpdated: '2018-09-25'
        }
    ];
    const sortedData = _reverse(_sortBy(data, [item => {
        const date = new Date(item.lastUpdated);
        const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        return newDate.getTime();
    }]));

    return (
        <Box fontSize="sm">
            <Table
                hoverable={true}
                useFixedHeader={true}
                columns={columns}
                data={sortedData}
            />
        </Box>
    );
};

export default RuleList;
